<template>
  <div id="pageNotFoundComponent" v-if="globals.currentUserRole > 0">
    <h1>&#128533;</h1>
    <h2>Oh no! How did you get here?</h2>
    <br />
    <a @click="setInitialRoute">Click here to get back on track</a>
  </div>
</template>

<script>
export default {
  methods: {
    setInitialRoute() {
      if (this.globals.currentUserRole === 1) {
        this.globals.currentUserInfo.IsAudiUser
          ? this.$router.push("/locationmanagement")
          : this.$router.push("/clientmanagement");
      } else {
        this.$router.push("/checkmanagement");
      }
    },
  },
};
</script>

<style scoped>
#pageNotFoundComponent {
  overflow: auto;
  height: calc(100vh - 60px);
  height: fill-available;
}

h1 {
  padding: 20vh 10px 10px 10px;
  font-weight: 500;
  font-size: 10em;
  color: gray;
}
h2 {
  font-size: 2em;
}
a {
  font-size: 1.2em;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// PageNotFound.vue?24bee17a